import MenuList from "./MenuList";
import { TMenuList, TListItem } from "./MenuList";

export type { TMenuList, TListItem };
export default MenuList;
